import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseResourceService, LiquidacaoResto } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class LiquidacaoRestoService extends BaseResourceService<LiquidacaoResto> {

  constructor(
    protected injector: Injector
  ) {
    super(`liquidacoes-restos-pagar`, injector);
  }

  public obterPorNumero(numero: number, ano: number, orgaoId: number): Observable<LiquidacaoResto> {
    return this.http.get<LiquidacaoResto>(
      `${this.login.cidade.id}/${this.api}?numero=${numero}&exercicio_ano=${ano}&orgao_id=${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterTotalLiquidadoPorEmpenho(numero: number, ano: number, parcela: number, orgaoId: number, idExclusao?: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/total-liquidado-por-empenho/${numero}/${ano}/${parcela}/${orgaoId}`
      + (idExclusao ? `?id_exclusao=${idExclusao}` : ''),
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterUltimaParcela(numero: number, exercicioId: number, orgaoId: number): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/ultima-parcela/${numero}/${exercicioId}/${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
  
  public ultimaDataLiquidada(exercicio: number, orgaoId: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/ultima-data-liquidada/${exercicio}/${orgaoId}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
